import PartnersHomePage from '@/apps/explore/PartnersHomePage.vue';
import { requireSeeker } from '../guards/authGuards';

const exploreRoutes = [
  {
    path: '/explore/partners',
    name: 'explore-partners',
    component: PartnersHomePage,
    beforeEnter: requireSeeker,
  },
  { path: '/explore', redirect: { name: 'explore-partners' } },
];

export default exploreRoutes;
